<template>
  <div>
    <infoBackground></infoBackground>
    <a-spin class="spin-box" :spinning="loading">
      <div class="pay-order">
        <div class="pay-title">提交订单成功</div>
        <div class="goods-info">
          <div class="goods-title">{{ goodsInfo?.title }}</div>
          <div class="goods-title goods-price-box">
            <span>{{ pay_success ? '支付金额' : '待支付' }}</span> ：￥
            <span class="goods-price">
              {{ orderInfo?.payMoney }}
            </span>
          </div>
        </div>
        <div class="pay-box" v-if="!pay_success">
          <div class="pay-type">
            <div class="pay-type-item">
              <i class="icon" :class=[payMethods[currentPayMethod].icon]></i>
              <span>{{ payMethods[currentPayMethod].name }}</span>
            </div>
          </div>
          <!-- 非微信环境使用 Native，展示二维码供扫码支付。 -->
          <a-spin class="spin-box" :spinning="isPaying" v-if="activePayType === 'native'">
            <div class="qrCode-box">
              <vue-qr class="qrCode" :text="payurl" :size="300" v-if="payurl"></vue-qr>
            </div>
          </a-spin>

          <div class="notice" v-if="activePayType === 'native'">
            <svg class="svg-icon icon-scan">
              <use xlink:href="#icon-saoma" />
            </svg>
            <span>请打开{{ payMethods[currentPayMethod].name }}扫描二维码支付</span>
          </div>
          <div class="return" @click="returnBack">暂不支付</div>
        </div>
        <div class="pay-box finish-box" v-if="pay_success">
          <i class="finish-icon"></i>
          <div class="finish-title">支付成功</div>
          <div class="finish-notice">
            恭喜您已经完成支付，订单
            <span class="waite-time">{{ waitingTime }}s</span>后将自动跳转
          </div>
          <a-button size="large" class="finish-btn" @click="returnBack" type="primary">立即学习</a-button>
        </div>
      </div>
      <!-- 页脚 -->
      <foot v-if="!loading"></foot>
    </a-spin>
  </div>
</template>

<script>
import foot from "@/component/public/foot/foot.vue";
import VueQr from 'vue-qr/src/packages/vue-qr.vue';
import infoBackground from "@/component/public/info-background/info-background.vue";

export default {
  name: 'pay-order',
  components: {
    VueQr, foot, infoBackground
  },
  data() {
    return {
      orderGuid: '',
      goodsGuid: '',
      couponGuid: null,
      payurl: '',
      activePayType: 'native',
      formHtml: '',
      waitingTime: 10,

      orderInfo: null,
      goodsInfo: null,
      userInfo: null,
      intPay: null,
      currentStore: null,

      loading: true,
      isPaying: false,
      pay_success: false,
      phoneMode: false,
      isWechatBrowser: /micromessenger/i.test(navigator.userAgent),
      lastWechatConfirmTime: 0,

      currentPayMethod: 0,
      payMethods: [
        { name: '微信支付', type: 'wechatpay', icon: 'wx-icon', value: 0 },
        { name: '支付宝', type: 'alipay', icon: 'zhb-icon', value: 1 }
      ],
    }
  },
  mounted() {
    const { userInfo, phoneMode, currentStore } = this.$store.state;
    this.userInfo = userInfo;
    this.phoneMode = phoneMode;
    this.currentStore = currentStore;

    const { currentPayMethod } = this.$route.query;
    if (currentPayMethod) this.currentPayMethod = currentPayMethod;

    this.findOrder();
  },
  methods: {
    //查找支付订单判断是否支付
    async findOrder() {
      try {
        this.orderGuid = this.$route.params.id;
        const res = await this.$api.payorder.findPayOrder({ pk_payorderGuid: this.orderGuid });
        if (res.statusCode != 200) {
          this.loading = false;
          return this.$message.error(res.message);
        }

        const data = res.data;
        this.orderInfo = data;
        this.goodsGuid = data.fk_goodsGuid;
        await this.loadPaymentContext();
        this.loading = false;

        if (this.orderInfo.isPaid || await this.confirmWechatOrder()) return this.payFinish();
        await this.payOff();
      } catch (error) {
        this.loading = false;
        this.$message.error(error.message || '订单信息加载失败');
      }
    },
    async loadPaymentContext() {
      const storeBooks = this.$store.state.storeBooks || [];
      this.goodsInfo = storeBooks.find(item => item.pk_store_book_id == this.goodsGuid);

      const [storeRes, bookRes] = await Promise.all([
        this.currentStore ? Promise.resolve(null) : this.$api.bookManage.storeFindOne(),
        this.goodsInfo ? Promise.resolve(null) : this.$api.bookManage.storeBookFindOne(this.goodsGuid),
      ]);

      if (!this.currentStore && (storeRes?.code === 1 || storeRes?.statusCode == 200) && storeRes.data) {
        this.currentStore = storeRes.data;
        this.$store.commit('setCurrentStore', storeRes.data);
      }

      if (!this.goodsInfo && (bookRes?.code === 1 || bookRes?.statusCode == 200) && bookRes.data) {
        this.goodsInfo = bookRes.data;
        if (this.goodsInfo.extension_info?.cover) {
          this.goodsInfo.cover = this.goodsInfo.extension_info.cover + '!260x390';
        }
        if (this.goodsInfo.extension_info?.banner) {
          this.goodsInfo.banner = this.goodsInfo.extension_info.banner + '!750x230';
        }
        this.$store.commit('setStoreBooks', [...storeBooks, this.goodsInfo]);
      }
    },
    getWechatOpenidStorageKey() {
      return `wechat_openid_${this.currentStore?.fk_publishing_agency_id || 'default'}`;
    },
    getWechatOauthStateStorageKey() {
      return `${this.getWechatOpenidStorageKey()}_oauth_state`;
    },
    clearWechatOauthQuery() {
      const url = new URL(location.href);
      url.searchParams.delete('code');
      url.searchParams.delete('state');
      history.replaceState({}, document.title, url.toString());
    },
    async getWechatOpenid() {
      const storageKey = this.getWechatOpenidStorageKey();
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const state = params.get('state');
      const stateStorageKey = this.getWechatOauthStateStorageKey();
      const expectedState = sessionStorage.getItem(stateStorageKey);
      if (code && state && state === expectedState) {
        const res = await this.$api.payorder.getWechatOpenid({
          code,
          state,
          fk_publishing_agency_id: this.currentStore.fk_publishing_agency_id,
        });
        if (res.statusCode !== 200 || !res.data?.openid) {
          throw new Error(res.message || '获取微信用户身份失败');
        }
        sessionStorage.setItem(storageKey, res.data.openid);
        sessionStorage.removeItem(stateStorageKey);
        this.clearWechatOauthQuery();
        return res.data.openid;
      }

      if (code || state) {
        sessionStorage.removeItem(stateStorageKey);
        this.clearWechatOauthQuery();
        throw new Error('微信授权状态无效，请重新发起支付');
      }

      const storedOpenid = sessionStorage.getItem(storageKey);
      if (storedOpenid) return storedOpenid;

      const redirectUrlObject = new URL(location.href);
      redirectUrlObject.searchParams.delete('code');
      redirectUrlObject.searchParams.delete('state');
      const res = await this.$api.payorder.getWechatOauthUrl({
        redirect_url: redirectUrlObject.toString(),
        fk_publishing_agency_id: this.currentStore.fk_publishing_agency_id,
      });
      if (res.statusCode !== 200 || !res.data?.url) {
        throw new Error(res.message || '无法获取微信授权地址');
      }
      sessionStorage.setItem(stateStorageKey, res.data.state);
      location.replace(res.data.url);
      return null;
    },
    async invokeWechatPay(payData) {
      if (!payData || typeof payData !== 'object') throw new Error('微信支付参数无效');
      const invoke = () => new Promise((resolve, reject) => {
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
          appId: payData.appId,
          timeStamp: payData.timeStamp,
          nonceStr: payData.nonceStr,
          package: payData.package,
          signType: payData.signType || 'RSA',
          paySign: payData.paySign,
        }, resolve);
        setTimeout(() => reject(new Error('微信支付调起超时')), 30000);
      });

      if (typeof window.WeixinJSBridge === 'undefined') {
        await new Promise((resolve, reject) => {
          const onReady = () => {
            clearTimeout(timer);
            resolve();
          };
          const timer = setTimeout(() => {
            document.removeEventListener('WeixinJSBridgeReady', onReady);
            reject(new Error('微信支付环境未就绪'));
          }, 10000);
          document.addEventListener('WeixinJSBridgeReady', onReady, { once: true });
        });
      }

      const result = await invoke();
      if (result?.err_msg !== 'get_brand_wcpay_request:ok') {
        if (result?.err_msg === 'get_brand_wcpay_request:cancel') throw new Error('用户取消支付');
        throw new Error(result?.err_desc || result?.err_msg || '微信支付失败');
      }
    },
    async confirmWechatOrder() {
      if (this.orderInfo?.payType !== 'wechatpay' || !this.orderInfo.out_trade_no) return false;
      const now = Date.now();
      if (now - this.lastWechatConfirmTime < 10000) return false;
      this.lastWechatConfirmTime = now;

      try {
        const res = await this.$api.payorder.confirmWechatOrder({ pk_payorderGuid: this.orderGuid });
        if (res.statusCode !== 200 || !res.data?.isPaid) return false;
        this.orderInfo = { ...this.orderInfo, ...res.data, isPaid: 1 };
        return true;
      } catch (_) {
        return false;
      }
    },
    //支付
    async payOff() {
      if (this.isPaying) return;
      if (!this.orderInfo || !this.goodsInfo || !this.currentStore) {
        return this.$message.error('支付信息加载失败，请刷新后重试');
      }
      this.isPaying = true;
      let orderInfo = this.orderInfo;
      let goodsInfo = this.goodsInfo;
      let returl = ``;
      if (this.phoneMode) returl = `https://lessonplay_view_page.lessonplan.cn/pay-finish/${this.goodsGuid}`;
      //需要支付
      try {
        if (goodsInfo.price > 0) {
          const payType = this.currentPayMethod == 0 && this.isWechatBrowser ? 'jsapi' : 'native';
          this.activePayType = payType;
          const body = {
            pk_payorderGuid: orderInfo.pk_payorderGuid,
            price: orderInfo.payMoney,
            name: goodsInfo.name,
            returl,
            fk_publishing_agency_id: this.currentStore.fk_publishing_agency_id,
            payType,
          }
          if (payType === 'jsapi') {
            body.openid = await this.getWechatOpenid();
            if (!body.openid) {
              this.isPaying = false;
              return;
            }
          }
          //获取支付地址
          let subRes;
          if (this.currentPayMethod == 0) subRes = await this.$api.payorder.wechatSubmitOrder(body);
          else subRes = await this.$api.payorder.aliSubmitOrder(body);

          if (subRes.statusCode != 200) {
            this.isPaying = false;
            return this.$message.error(subRes.message);
          }
          if (payType === 'jsapi') {
            await this.invokeWechatPay(subRes.data);
          } else {
            this.payurl = subRes.data.code_url || subRes.data.h5_url || subRes.data;
            // Native 二维码需要留在当前页面展示，不能在手机端直接跳转 code_url。
          }

          //循环兼听支付结果
          this.intPay = setInterval(() => { this.listenPay() }, 3000);
        }
        else this.payFinish();
      } catch (error) {
        this.$message.error(error.message || '支付失败');
      }
      this.isPaying = false;
    },
    //兼听支付状态
    async listenPay() {
      try {
        const res = await this.$api.payorder.findPayOrder({ pk_payorderGuid: this.orderGuid });
        if (res.statusCode != 200) {
          clearInterval(this.intPay);
          return this.$message.error(res.error);
        }
        this.orderInfo = res.data || this.orderInfo;
        if (res.data?.isPaid || await this.confirmWechatOrder()) {
          clearInterval(this.intPay);
          this.payFinish();
        }
      } catch (_) {
        // 下一次轮询会继续确认，短暂网络异常不应中断支付状态检查。
      }
    },
    //支付成功
    async payFinish() {
      this.pay_success = true;
      //购买成功，更新购买状态
      const { storeBooks } = this.$store.state;
      storeBooks.forEach((item) => {
        if (item.pk_store_book_id === this.goodsGuid) {
          item.isPaid = true;
        }
      })
      this.$store.commit("storeBooks", JSON.parse(JSON.stringify(storeBooks)));

      const that = this;
      const int = setInterval(() => {
        if (that.waitingTime <= 0) {
          clearInterval(int);
          that.returnBack();
        }
        that.waitingTime -= 1;
      }, 1000);
    },
    //返回
    returnBack() {
      clearInterval(this.intPay);
      this.$router.push(`/course-info/${this.goodsGuid}`);
    },
  }
}


</script>

<style scoped lang="scss">
@import "./pay-order.scss";
</style>
